import React from 'react';
import PropTypes from 'prop-types';

const StatusText = ({ title, children }) => (
  <>
    <h1
      className="mt-5 text-2xl leading-8 font-semibold"
      style={{ marginBottom: '8px' }}
    >
      {title}
    </h1>
    <div className=" w-2/3 text-center" style={{ marginBottom: '32px' }}>
      <p className="font-normal text-sm">{children}</p>
    </div>
  </>
);

StatusText.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default StatusText;
